import { fetchDataFromPresignedURLEpic } from "./fetchDataFromPresignedURLEpic";
import { generateReportAsyncEpic } from "./generateReportAsyncEpic";
import generatePresignedUrlEpic from "./getDDUOptionsEpic";
export var generateReportEpics = [
    generateReportAsyncEpic,
    generatePresignedUrlEpic,
    fetchDataFromPresignedURLEpic
];
export default generateReportEpics;

//# sourceMappingURL=index.js.map